// ── ForwardRateForm ──
import { B } from "../../../shared/theme";
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const ForwardRateForm = ({ initial, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
  console.log('ForwardRateForm rendered', { readOnly, type: modal?.type });
    const [f, set] = useFreshForm(initial || {
      curvedate:'', ratedate:'', rate:'', ratedescription:'', indexname:''
    }, "ForwardRates");

    const INDEX_OPTIONS = [
      { value:'',      label:'— Select Index —' },
      { value:'SOFR',  label:'SOFR'  },
      { value:'BSBY',  label:'BSBY'  },
      { value:'Prime', label:'Prime' },
      { value:'LIBOR', label:'LIBOR' },
      { value:'Other', label:'Other' },
    ];

    const ST = ({ title }) => <div style={{ gridColumn:'1/-1', fontSize:11, fontWeight:600, color:B.cyanDark, textTransform:'uppercase', letterSpacing:'0.06em', marginTop:18, marginBottom:8, paddingBottom:4, borderBottom:'1.5px solid '+B.cyanLight }}>{title}</div>;

    return <Modal title={readOnly?'View Forward Rate':initial?'Edit Forward Rate':'Add Forward Rate'} onClose={closeModal}
      onEdit={readOnly&&role.canEdit?()=>{ closeModal(); setModal({type:'forward-rate-edit',rec:initial,onDone:modal.onDone}); }:null}>
      <ReadOnlyForm readOnly={readOnly}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0 24px' }}>
          <ST title="Rate Details" />
          <Field label="Index"><FSelect value={f.indexname||''} onChange={set('indexname')} options={INDEX_OPTIONS} /></Field>
          <Field label="Curve Date"><FInput type="date" value={f.curvedate?.slice(0,10)||''} onChange={set('curvedate')} /></Field>
          <Field label="Rate Date"><FInput type="date" value={f.ratedate?.slice(0,10)||''} onChange={set('ratedate')} /></Field>
          <Field label="Rate (e.g. 0.0531 = 5.31%)"><FInput type="number" step="0.0001" value={f.rate} onChange={set('rate')} /></Field>
          <Field label="Description" style={{ gridColumn:'1/-1' }}><FInput value={f.ratedescription||''} onChange={set('ratedescription')} /></Field>
        </div>
      </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:'#993C1D',fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      <div style={{ display:'flex',gap:8,justifyContent:'flex-end',marginTop:16 }}>
        <Btn onClick={closeModal}>{readOnly?'Close':'Cancel'}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec('saveForwardRate',f,initial?'Edited':'Added','ForwardRates',(initial?'Updated':'Added')+' forward rate',modal.onDone)} variant="primary">{saving?'Saving...':'Save'}</Btn>}
      </div>
    </Modal>;
  };
